import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { COLORS } from "@app/constants";
import { Text, View } from "@/styles/reactnative";
import { IconChevronDown } from "@tabler/icons-react";
import { ThemeContext } from "@/theme/ThemeProvider";
import { Select } from 'antd';
import styled from "styled-components";

const DepositAutoChanneled = () => {
  const { textsilver, descBox } = useContext(ThemeContext).theme.COLORS;
  const [depositType, setDepositType] = useState("spot");
  const [display, setDisplay] = useState(false);
  const { t } = useTranslation();
  const list = ["spot", "tradeaccount"];

  const handleChange = (item:any) => {
    setDepositType(item);
    setDisplay(!display);
  }

  return (
    <View style={{ width: "100%", alignItems: "flex-start", marginTop: 20 }}>
      <Text>{t("depositsAutoChanneledTo")}</Text>
      <StyleSelect onChange={handleChange} defaultValue={depositType}>
        {list?.map((item, index) => (
          <Select.Option key={index.toString()} value={item}>
            {t(item)}
          </Select.Option>
        ))}
      </StyleSelect>
    </View>
  );
};

export default DepositAutoChanneled;

const StyleSelect = styled(Select)`
  width: 100%;
  margin-top: 10px;
`